import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ResponseModel } from '@dental-ui/account/models';
import { buildApiUrl, buildRequestHeaders } from '@dental-ui/shared/consts';

export interface FeatureDto {
  id: string;
  name: string;
  code: string;
  isActive: boolean;
  currencyType: string;
  monthlyPrice: number;
  yearlyPrice: number;
  monthlyDiscount: number;
  yearlyDiscount: number;
  totalMonthlyPrice: number;
  totalYearlyPrice: number;
}

export interface FeaturePaginationData {
  data: FeatureDto[];
  totalPage: number;
  totalRecord: number;
}

@Injectable({ providedIn: 'root' })
export class PortalPackageContentsApiService {
  private readonly http = inject(HttpClient);

  getFeatures(page: number, pageSize: number, name?: string): Observable<FeaturePaginationData> {
    const body = {
      PaginationRequestModel: { page: page + 1, numberOfRecord: pageSize, sortColumn: '', sortOrder: '' },
      FeatureFilterRequestDto: { name: name ?? '' },
    };
    return this.http
      .post<ResponseModel<FeaturePaginationData>>(
        buildApiUrl('feature.getAllByFilter'),
        body,
        { headers: buildRequestHeaders(true) }
      )
      .pipe(map((res) => res.data ?? { data: [], totalPage: 0, totalRecord: 0 }));
  }

  createFeature(model: Omit<FeatureDto, 'id'>): Observable<unknown> {
    return this.http.post(
      buildApiUrl('feature.create'),
      model,
      { headers: buildRequestHeaders(true) }
    );
  }

  updateFeature(model: FeatureDto): Observable<unknown> {
    return this.http.put(
      buildApiUrl('feature.update'),
      model,
      { headers: buildRequestHeaders(true) }
    );
  }

  deleteFeature(id: string): Observable<unknown> {
    return this.http.delete(
      `${buildApiUrl('feature.delete')}?feature=${id}`,
      { headers: buildRequestHeaders(true) }
    );
  }
}
